import { render, staticRenderFns } from "./CreateDiscount.vue?vue&type=template&id=a7746d5c&scoped=true&"
import script from "./CreateDiscount.vue?vue&type=script&lang=ts&"
export * from "./CreateDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7746d5c",
  null
  
)

export default component.exports